/**
 * The UTC offsets, in hours, that a user can select.
 *
 * The list is written out, not generated from a range. It looks like a
 * half-hour sequence, but it is not one. It has no `-11:30` and no `-10:30`,
 * and `+05:45`, `+12:45` and `+13:45` are off the half-hour grid. A generated
 * list would therefore change which offsets exist.
 *
 * `@navstation-portal/shared/util/time` derives the rest from these numbers.
 * It derives the `(UTC±HH:MM)` label and the key the cloud API carries. A label
 * cannot disagree with its offset, and a selectable offset is always sendable.
 */
export const SELECTABLE_UTC_OFFSETS: readonly number[] = [
  -12, -11, -10, -9.5, -9, -8.5, -8, -7.5, -7, -6.5, -6, -5.5, -5, -4.5, -4, -3.5, -3, -2.5, -2, -1.5, -1, -0.5, 0, 0.5,
  1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 5.75, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 12.75, 13,
  13.5, 13.75, 14,
];

/**
 * The offsets that stay readable, but that a user can no longer select.
 *
 * `-12:30` is not a real offset, because it crosses the international date
 * line. It left the dropdown. The cloud API keeps its key and can still hold
 * reports saved against it, so the offset stays on the read path. A stored
 * report shows a labelled offset, and keeps that offset when a user edits a
 * different field. No user can select it again.
 *
 * This list holds one retired offset. It is not a mechanism to retire offsets.
 */
export const LEGACY_UTC_OFFSETS: readonly number[] = [-12.5];

/** The offset a user has until the user selects a different one. */
export const DEFAULT_UTC_OFFSET = 0;

export const DATE_FORMAT = 'dd/MM/yyyy HH:mm';
